<prlw-common-pane>
  <prlw-icon name="sandwich" (click)="eventClick.emit()"></prlw-icon>
</prlw-common-pane>
